export const formatPath = (path, maxLength = 150) => {
    if (path.length <= maxLength) {
        return path;
    } else {
        const parts = path.split('/');
        let currentLength = 0;
        const resultParts = [];

        for (let i = parts.length - 1; i >= 0; i--) {
            if (currentLength + parts[i].length + resultParts.length > maxLength) {
                break;
            }
            resultParts.push(parts[i]);
            currentLength += parts[i].length;
        }

        resultParts.reverse();
        return `.../${resultParts.join('/')}`;
    }
};

/**
 * Path for display in a narrow column: inserts a zero-width space after every
 * separator so the browser wraps at `\` / `/` instead of mid-word. Pair with
 * `overflow-wrap: anywhere` as the fallback for single overlong segments.
 */
export const wrappablePath = (path) => (path ? String(path).replace(/[\\/]/g, '$&​') : path);
